import Vue from "vue";
import moment from "moment";

Vue.filter("jsDate", function (value, format) {
  if (value != null) {
    //let formatDate = moment(new Date(parseInt(x.substr(6)), format));
    let dtDate = /*Vue.prototype.$*/ moment(value); //.format(format);
    let formatDate = dtDate.format(format);
    return formatDate;
  } else return null;
});

Vue.filter("fileSize", function (value) {
  if (isNaN(value) || value == null) value = 0;
  if (value < 1024) return value + " Bytes";
  value /= 1024;
  if (value < 1024) return value.toFixed(2) + " Kb";
  value /= 1024;
  if (value < 1024) return value.toFixed(2) + " Mb";
  value /= 1024;
  if (value < 1024) return value.toFixed(2) + " Gb";
  value /= 1024;
  return value.toFixed(2) + " Tb";
});

Vue.filter("numberThousandSeparator", function (value, separator, floor) {
  if (floor) {
    return Math.floor(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  } else {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }
});

Vue.filter("integerFormat", function (value, separator) {
  if (value)
    return Math.round(value)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  else return _.isNaN(value) ? null : value;
});

Vue.filter("numericFormat", function (value, separator, decimals) {
  if (value)
    return value
      .toFixed(decimals)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  else return _.isNaN(value) ? null : value;
});

Vue.filter("capitalize", (str) => _.capitalize(str));
